import type { OtherDocumentsLabelProps } from './types';

export const getOtherDocumentsLabel = (...props) => {
  const [otherDocumentsState, otherDocumentLabels, allSelected, useShortLabel, documentLabelsTitle, furtherDocumentLabelsTitle, allDocumentLabelsTitle] = props as OtherDocumentsLabelProps;

  const docLabel = useShortLabel ? documentLabelsTitle : furtherDocumentLabelsTitle;

  return allSelected === 1
    ? allDocumentLabelsTitle
    : allSelected === 0
      ? docLabel
      : otherDocumentLabels.reduce<string>((prev, curr, _) => `${prev}${prev.length > 0 && otherDocumentsState[curr.key] ? ', ' : ''}` + `${otherDocumentsState[curr.key] ? curr.shortlabel : ''}`, '');
};
